<script lang="ts">
  import Link from "svelte-link";
  import { FormGroup } from "sveltestrap";
  import FeatherIcons from 'svelte-feather-icon';
  import { CreateAccount, Donthaveaccount, href } from "../utils/Constant/Constant";

</script>
<FormGroup>
  <ul class="login-social">
    <li>
      <Link href="https://www.linkedin.com/login" target="_blank">
        <FeatherIcons icon="linkedin" />
      </Link>
    </li>
    <li>
      <Link href="https://twitter.com/" target="_blank">
        <FeatherIcons icon="twitter" />
      </Link>
    </li>
    <li>
      <Link href="https://www.facebook.com/" target="_blank">
        <FeatherIcons icon="facebook" />
      </Link>
    </li>
    <li>
      <Link href="https://www.instagram.com/login" target="_blank">
        <FeatherIcons icon="instagram" />
      </Link>
    </li>
  </ul>
</FormGroup>
<p>{Donthaveaccount}<Link class="ms-2" href={href}>{CreateAccount}</Link></p>